import React, { useState, useCallback, useEffect } from 'react';
import { debounce } from 'lodash';
import { ATMDropdown, ATMInput, IORGDataTableQueryState } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import styles from './table-search.module.scss';

type IProps = {
  state: IORGDataTableQueryState;
  dropdown?: boolean;
  setState: (params: IORGDataTableQueryState) => void;
  setClear?: (data: boolean) => void;
};

const TableSearch: React.FC<IProps> = ({
  state,
  dropdown = false,
  setState,
  setClear,
}) => {
  const [ticket, setTicket] = useState(state.ticket ?? '');
  const [flightNo, setFlightNo] = useState(state.flightNo ?? '');
  const [searchType, setSearchType] = useState<any>('flightNo');

  useEffect(() => {
    setTicket(state.ticket ?? '');
    setFlightNo(state.flightNo ?? '');
  }, [state]);

  const handleKeyUp = useCallback(
    debounce((text) => {
      if (typeof text === 'string') {
        setState({
          ...state,
          ticket: searchType === 'ticket' && text.trim().length ? text.trim() : undefined,
          flightNo: searchType === 'flightNo' && text.trim().length ? text.trim() : undefined,
        });
      }
    }, 1000),
    [searchType, state, setState]
  );

  const handleClear = useCallback(() => {
    setTicket('');
    setFlightNo('');
    setState({
      page: 1,
      limit: 0,
    });
    if (setClear) {
      setClear(true);
    }
  }, [setTicket, setFlightNo, setState, setClear]);

  const hasValue = !!ticket.trim().length || !!flightNo.trim().length;

  const labelDropdown = dropdown && (
    <ATMDropdown
      basic
      defaultValue="flightNo"
      options={
        [
          {
            key: 'flightNo',
            value: 'flightNo',
            text: 'Flight No.'
          },
          {
            key: 'ticket',
            value: 'ticket',
            text: 'Request ID'
          },
        ]
      }
      onChange={(_, { value }) => setSearchType(value)}
    />
  );

  return (
    <ATMInput
      label={labelDropdown}
      labelPosition={dropdown ? 'right' : undefined}
      className={dropdown ? styles.wrapper2 : styles.wrapper}
      placeholder={searchType === 'ticket' ? Lang.LBL_TICKET_SEARCH : Lang.LBL_FLIGHT_SEARCH}
      value={ticket || flightNo}
      onChange={(_, data) => searchType === 'ticket' ?
        setTicket(data.value) :
        setFlightNo(data.value)
      }
      onKeyUp={(e) => handleKeyUp(e.target.value)}
      icon={{
        name: hasValue ? 'close' : 'search',
        link: hasValue,
        onClick: hasValue ? handleClear : undefined,
      }}
    />
  );
};

export default TableSearch;
